exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-image-row img[data-v-30a42e74] {\n  max-width: 100px;\n  max-height: 100px;\n}\n.product-image-row.remove img[data-v-30a42e74] {\n  max-width: 20px;\n  max-height: 20px;\n}", ""]);

// exports
